import React from 'react';

export default () => <div>There was an error displaying the block.</div>;
